const {FIELDS} = require("../constants");
const {PAYMENT_METHODS_LIST} = require("../../../../../constants/paymentMethods");

module.exports = (items, fn) => {
  PAYMENT_METHODS_LIST.forEach((method) => {
    const row = items.find((el) => method.id === el.payment_method) || {};
    FIELDS.forEach((key) => fn(method.id, row, key));
  })
}
